/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Danish (Denmark)
export default {
  'confluence-analytics-chart.default-loading-text': 'Opdaterer analysedata …',
  'confluence-analytics-chart.tooltip.no-views-data': 'Ingen data',
  'confluence-analytics-chart.tooltip.views-overall': '{count, plural, one {1 visning} other {{count} visninger}}',
  'confluence-analytics-chart.tooltip.views-today-so-far':
    '{count, plural, one {1 visning indtil videre} other {{count} visninger indtil videre}}',
  'confuence-analytics-chart.accessible-table.caption': 'Sidevisninger',
  'confuence-analytics-chart.accessible-table.header.date': 'Dato',
  'confuence-analytics-chart.accessible-table.header.view-count': 'Visninger',
  'confuence-analytics-chart.accessible-table.no-view-count-data': 'Ingen visninger',
};
